import { ESPopover } from '@energy-stacks/core/ui';
import { useRemovePlantIdPrefix } from '@energy-stacks/fleet/feature-business-accounts';
import { ContaminationViolation } from '@energy-stacks/fleet/feature-tours-data';
import { Box, SxProps } from '@mui/material';
import { IconAlertTriangle } from '@tabler/icons-react';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type JobContaminationWarningProps = {
  contaminationViolation: ContaminationViolation;
  isNextTourViolation?: boolean;
  sx?: SxProps;
};

export const JobContaminationWarning: FC<JobContaminationWarningProps> = ({
  contaminationViolation,
  sx,
}) => {
  const [t] = useTranslation('tours');
  const removePlantIdPrefix = useRemovePlantIdPrefix();

  if (!contaminationViolation.conflictingJobOrigin) {
    return null;
  }

  const conflictingJobId = removePlantIdPrefix(
    contaminationViolation.conflictingJobId
  );

  return (
    <ESPopover
      content={
        <Trans
          t={t}
          i18nKey={`contaminationWarningPopover.job.${contaminationViolation.conflictingJobOrigin}`}
          values={{
            conflictingJobId,
          }}
        >
          This job violates the contamination rules due to its position after
          job <strong>#conflictingJobId</strong>
          <br />
          Remove or rearrange the jobs in this tour to resolve contamination
          rule violation.
        </Trans>
      }
    >
      <Box
        data-testid="jobContaminationWarning"
        sx={{
          alignItems: 'center',
          display: 'flex',
          color: 'error.dark',
          ...sx,
        }}
      >
        <IconAlertTriangle />
      </Box>
    </ESPopover>
  );
};
